
import { Component, Injectable  } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from 'src/app/core/store/store';

@Injectable({
	providedIn: 'root'
  })

@Component({
	selector: 'loading',
	template: `<div *ngIf="organizationLoader || activationLoader || dashboardLoader || elementLoader" id="pause" class="align-items-center loader-class justify-content-center"><div id="spinner"></div></div>`,
	styleUrls: ['loading.scss']
})

export class LoadingComponent {
	resposeData: Subscription
	data: any
	organizationLoader: any
	activationLoader: any
	dashboardLoader: any
	elementLoader: any
	constructor(private store: Store) {}

	ngOnInit(): void {
		this.store.select('organizationLoader').subscribe((loader) => {
			this.organizationLoader = loader;
		});
		this.store.select('elementLoader').subscribe((loader) => {
			this.elementLoader = loader;
			
		});
		this.store.select('dashboardLoader').subscribe((loader) => {
			this.dashboardLoader = loader;
			
		});
		this.store.select('activationLoader').subscribe((loader) => {
			this.activationLoader = loader;
			
		});

	}
	// public showSpinner() {
	// 	this.show = true
	// }

	// public hideSpinner() {
	// 	this.show = false
	// }
}
